import React from "react";
import "../../style/Footer/ButtonsSiguiente.css";
import Button from "react-bootstrap/Button";
import { useAppContext } from "../../AppContext";

export default function ButtonsSiguiente({ ...props }) {
  const { globalState, setGlobalState } = useAppContext({});

  const handleSelect = () => {
    setGlobalState({
      ...globalState,
      step: "3",
      aditionalNavbar: true,
    });
  }
  return (
    <>
          <Button
            variant="outline-primary"
            className="btn-icon-siguiente"
            onClick={() => handleSelect()}
          >
            <span className="button-text">Siguiente</span>
          </Button>
    </>
  );
}
